/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
// import auth from '@/auth/authService'
// import webauth from './webauth/auth'
import store from './store/store'

// import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

function checkPermission (module, entity) {
  let pagePermission = false
  let permissionList = []
  if (store.getters.get_role_permission === 1) {
    pagePermission = true
  } else {
    store.getters.get_navmenu_item_data.forEach(menu => {
      if (module === menu.module_name && menu.has_permission) {
        permissionList = menu.action_list

      }
    })
    permissionList.forEach(element => {
      if (element.action_name === entity && element.enabled === 1) {
        pagePermission = true
      } else if (element.action_name === 'ViewOwn' && element.enabled === 1) {
        pagePermission = true
      }
    })
  }

  return pagePermission
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/admin/dashboard'
        },

        {
          path: '/dashboard/analytics',
          name: 'dashboard-analytics',
          component: () => import('./views/pages/dashboard/index.vue'),
          meta: {
            // breadcrumb: [{ title: 'Home', url: '/', active: true }],
            rule: 'editor',
            authRequired: true,
            customerIdRequired: true
          }
        },

        {
          path: '/admin/dashboard',
          name: 'admin-dashboard',
          component: () => import('./views/pages/v1/Admin/dashboard.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/', active: true }],
            rule: 'editor',
            authRequired: true,
            customerIdRequired: true
          }
        },
        {
          path: '/teacher/dashboard',
          name: 'teacher-dashboard',
          component: () => import('./views/pages/v1/Teacher/dashboard.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/', active: true }],
            rule: 'editor',
            authRequired: true,
            customerIdRequired: true
          }
        },
        {
          path: 'student-profile/:client_id',
          name: 'profile',
          component: () => import('./views/pages/v1/StudentProfile/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Students ', url: '/clients' },
              { title: 'Student Details', active: true }
            ],
            rule: 'editor',
            authRequired: true,
            customerIdRequired: true
          }
        },
        {
          path: '/pages/admission/',
          name: 'admission',
          component: () => import('./views/pages/v1/admission/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admission', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor'
          }
        },
        {
          path: '/pages/admission/newEnrollment',
          name: 'newEnrollment',
          component: () => import('./views/pages/v1/admission/newEnrollment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admission', url: '/pages/admission/' },
              { title: 'Enrollment', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor'
          }
        },
        {
          path: '/pages/admission/enrollment/:studentId',
          name: 'enrollment',
          component: () => import('./views/pages/admission/enrollment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admission', url: '/pages/admission/' },
              { title: 'Enrollment', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor'
          }
        },


        {
          path: '/pages/reset-password',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            customerIdRequired: true
          }
        },
        // Scoolio Main Menu
        {
          path: '/pages/files',
          name: 'files',
          component: () => import('./views/pages/files/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files', active: true }
            ],
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            customerIdRequired: true

          }
        },

        {
          path: '/pages/payroll',
          name: 'payroll',
          component: () => import('./views/pages/payroll/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Payroll', active: true }
            ],
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },


        //files testing component
        {
          path: '/pages/filetesting',
          name: 'filetesting',
          component: () => import('./views/pages/questions/components/filetesting.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'File Testing', active: true }
            ],
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        //files testing component

        {
          path: '/testing',
          name: 'Testing',
          component: () => import('./views/pages/Testing/index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            customerIdRequired: true,
            no_scroll: true
          }
        },
        {
          path: '/redirect',
          name: 'Redirect',
          component: () => import('./views/pages/Testing/redirect.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            customerIdRequired: true,
            no_scroll: true
          }
        },
        // {
        //   path: '/pages/questions-edit',
        //   name: 'Question-Edit',
        //   component: () => import('./views/pages/questions/edit.vue'),
        //   meta: {
        //     rule: 'editor',
        //     parent: 'todo',
        //     no_scroll: true
        //   }
        // },
        // {
        //   path: '/pages/testing',
        //   name: 'testing',
        //   component: () => import('./views/pages/questions/testing-vuedrop.vue'),
        //   meta: {
        //     rule: 'editor',
        //     parent: 'todo',
        //     no_scroll: true
        //   }
        // },


        {
          path: '/pages/email-template',
          name: 'email-template',
          component: () => import('./views/pages/email/emailTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Email Template', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        {
          path: '/pages/analytics',
          name: 'Analytics',
          component: () => import('./views/pages/analytics/index.vue'),
          meta: {
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },


        {
          path: '/pages/referrals',
          name: 'Referrals',
          component: () => import('./views/pages/referrals/index.vue'),
          meta: {
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        {
          path: '/pages/project-details/:id',
          name: 'project-details',
          component: () => import('./views/pages/task-project/project-details.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Tasks & Projects', url: '/pages/tasks-project' },
              { title: 'Project Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Projects',
            entity: 'ViewProject'
          }
        },
        // {
        //   path: '/pages/project',
        //   name: 'tasks',
        //   component: () => import('./views/pages/task-project/project-listing.vue'),
        //   meta: {
        //     rule: 'editor',
        //     parent: 'todo',
        //     no_scroll: true
        //   }
        // },
        {
          path: '/pages/questions',
          name: 'Questions',
          component: () => import('./views/pages/questions/index.vue'),
          meta: {
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },


        {
          path: '/paypal',
          name: 'Paypal',
          component: () => import('./views/pages/paypal/index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            customerIdRequired: true,
            no_scroll: true
          }
        },
        {
          path: '/stripe',
          name: 'Stripe',
          component: () => import('./views/pages/paypal/stripe.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            customerIdRequired: true,
            no_scroll: true
          }
        },

        // Lead/Crm Router main menu
        {
          path: '/pages/leads',
          name: 'Leads',
          component: () => import('./views/pages/leads/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CRM', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,

            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'CRM',
            entity: 'View'
          }
        },
        {
          path: '/pages/leads/lead-details/:leadId',
          name: 'leadDetails',
          component: () => import('./views/pages/leads/LeadDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CRM', url: '/pages/leads' },
              { title: 'CRM Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true,
            module: 'CRM',
            entity: 'View'
          }
        },
        {
          path: '/pages/leads/lead-edit/:leadId',
          name: 'lead-edit',
          component: () => import('./views/pages/leads/LeadEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CRM', url: '/pages/leads' },
              { title: 'CRM Edit', active: true }
            ],
            pageTitle: 'Lead Edit',
            rule: 'editor',
            customerIdRequired: true,
            module: 'CRM',
            entity: 'Edit'
          }
        },
        {
          path: '/lead-user-details/:lead_user_id',
          name: 'lead-user-details',
          component: () => import('./views/pages/leads/leadUserDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'lead ', url: '/pages/leads' },
              { title: 'lead Edit', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            requiresAuth: true,
            module: 'CRM',
            entity: 'View'
          }
        },
        //lead/Crm Router
        //schedule

        {
          path: '/pages/schedule',
          name: 'schedule',
          component: () => import('./views/pages/v1/schedule/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Schedule', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        //schedule

        //Staff/Teachers Route

        {
          path: '/staff',
          name: 'Staff',
          component: () => import('./views/pages/users/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Staff', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,

            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Teachers',
            entity: 'View'
          }
        },

        // {
        //   path: '/staff-details/:teacher_id',
        //   name: 'staff details',
        //   component: () => import('./views/pages/users/teacher-details.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Staff ', url: '/staff' },
        //       { title: 'Staff Details', active: true }
        //     ],
        //     authRequired: true,
        //     customerIdRequired: true,
        //     rule: 'editor',
        //     parent: 'todo',
        //     no_scroll: true,
        //     module: 'Teachers',
        //     entity: 'View'
        //   }
        // },
        //Staff Teachers Router

        //Client/Student Route
        {
          path: '/clients',
          name: 'students',
          component: () => import('./views/pages/students/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Students', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true,
            module: 'Students',
            entity: 'View'

          }
        },
        // {
        //   path: '/clients-details/:client_id',
        //   name: 'clients-details',
        //   component: () => import('./views/pages/students/clients-details.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Students ', url: '/clients' },
        //       { title: 'Student Details', active: true }
        //     ],
        //     rule: 'editor',
        //     parent: 'todo',
        //     no_scroll: true,
        //     authRequired: true,
        //     customerIdRequired: true,
        //     module: 'Students',
        //     entity: 'View'
        //   }
        // },
        {
          path: '/clients-user-details/:client_user_id',
          name: 'clients-user-details',
          component: () => import('./views/pages/students/clientUserDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Students ', url: '/clients' },
              { title: 'Student Edit', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true,
            module: 'Students',
            entity: 'View'
          }
        },
        //Client/Student Route


        //Finance Route
        {
          path: '/pages/finance',
          name: 'Finance',
          component: () => import('./views/pages/finance/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Student Finance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Finance',
            entity: 'getInvoicesList'
          }
        },
        {
          path: '/pages/manual-invoice',
          name: 'manual-invoice',
          component: () => import('./views/pages/manual-invoice/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manual Invoice', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Manual Invoice',
            entity: 'getInvoicesList'
          }
        },
        {
          path: '/manual-invoice',
          name: 'manual-invoice-form',
          component: () => import('./views/pages/manual-invoice/create.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manual Invoice', url: '/pages/manual-invoice' },
              { title: 'Create / Edit', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Manual Invoice Create',
            entity: 'getInvoicesList'
          }
        },
        {
          path: '/staffpayout',
          name: 'StaffPayout',
          component: () => import('./views/pages/finance/staffpayoutgenerate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Staff Payment', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Finance',
            entity: 'getInvoicesList'
          }
        },

        {
          path: '/staffpaidslip',
          name: 'StaffPaidSlip',
          component: () => import('./views/pages/finance/staffpaidslip.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Finance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
            /* module: 'Finance',
            entity: 'getInvoicesList' */
          }
        },


        {
          path: '/pages/finance-preview',
          name: 'invoice-preview',
          component: () => import('./views/pages/finance/components/InvoicePreview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Finance Preview', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Finance',
            entity: 'getInvoicesList'
          }
        },

        //Finance Route

        //Education Route


        {
          path: '/pages/classes',
          name: 'classes',
          component: () => import('./views/pages/classes/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/classes-create',
          name: 'classes-create',
          component: () => import('./views/pages/v1/classes/create.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', url: '/pages/classes' },
              { title: 'Create Class', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/classes-details',
          name: 'classes-details',
          component: () => import('./views/pages/v1/classes/details.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', url: '/pages/classes' },
              { title: 'Class Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/each-subject',
          name: 'each-subject',
          component: () => import('./views/pages/v1/classes/eachSubject.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', url: '/pages/classes' },
              { title: 'Class Details', url: '' },
              { title: 'Subject', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/classes/details/:class_id',
          name: 'class-details',
          component: () => import('./views/pages/classes/classDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', url: '/pages/classes' },
              { title: 'Class Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/classes/marklist/:class_id/:student_id',
          name: 'mark-list',
          component: () => import('./views/pages/classes/components/MarkList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', url: '/pages/classes' },
              { title: 'Mark List', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/classes/gradebook',
          name: 'class_gradebook',
          component: () => import('./views/pages/classes/components/ClassReportCard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Classes', url: '/pages/classes' },
              { title: 'Report Card', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        //grade
        {
          path: '/pages/grade',
          name: 'grade',
          component: () => import('./views/pages/grade/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Grade', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        //notes
        {
          path: '/pages/notes',
          name: 'notes',
          component: () => import('./views/pages/v1/notes/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Notes', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/gradebook',
          name: 'gradebook',
          component: () => import('./views/pages/grade/gradebook.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Grade', url: '/pages/grade' },
              { title: 'Gradebook', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        {
          path: '/pages/marklist',
          name: 'marklist',
          component: () => import('./views/pages/grade/marklist.vue'),
          meta: {
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        //grade

        {
          path: '/pages/subjects',
          name: 'Subjects',
          component: () => import('./views/pages/subjects/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Subjects', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true,
            module: 'Subject',
            entity: 'View'
          }
        },

        //assignment->report
        {
          path: '/pages/reports',
          name: 'Report',
          // component: () => import('./views/pages/reports/index.vue'),
          component: () => import('./views/pages/v1/coursework/Reports/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Reports', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Reports',
            entity: 'View'
          }
        },
        //assignment->report


        //assignment->exam

        {
          path: '/pages/exam',
          name: 'Exam',
          component: () => import('./views/pages/V1_Exam/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Exams', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Tests & Exams',
            entity: 'View'

          }
        },
        //assignment->exam

        //assignment->Homework

        {
          path: '/pages/coursework',
          name: 'Homework',
          component: () => import('./views/pages/v1/coursework/index'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Coursework', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Coursework',
            entity: 'View'
          }
        },
        {
          path: '/pages/coursework/preview',
          name: 'Preview',
          component: () => import('./views/pages/v1/coursework/preview'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Coursework', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Coursework',
            entity: 'View'
          }
        },
        //assignment->Homework

        //Course wizard
        {
          path: '/pages/coursebuilder',
          name: 'coursebuilder',
          component: () => import('./views/pages/v1/coursebuilder'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Courses', url: '/pages/course-builder/course' },
              { title: 'Coursebuilder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'Create'
          }
        },
        {
          path: '/pages/coursebuilder/:course_id/:course_class_type',
          name: 'course edit',
          component: () => import('./views/pages/v1/coursebuilder'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Courses', url: '/pages/course-builder/course' },
              { title: 'Coursebuilder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'Create'
          }
        },
        {
          path: '/pages/coursebuilder/:course_open_type/:course_id',
          name: 'course preview',
          component: () => import('./views/pages/v1/coursebuilder'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Courses', url: '/pages/course-builder/course' },
              { title: 'Coursebuilder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'Create'
          }
        },
        {
          path: '/pages/topicdetails',
          name: 'topicDetails',
          component: () => import('./views/pages/course-builder/ListingComponent/Topic/TopicDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Topics', url: '/pages/topiclist' },
              { title: 'Topic Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,

            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Topic',
            entity: 'View'
          }
        },
        //Course
        {
          path: '/pages/course-builder',
          name: 'course-builder',
          component: () => import('./views/pages/course-builder/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Course', url: '/pages/course-builder/course' },
              { title: 'Course Builder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'Create'
          }
        },
        {
          path: '/pages/course-builder/course',
          name: 'courseListing',
          component: () => import('./views/pages/course-builder/ListingComponent/CourseListing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Course', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,

            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'View'
          }
        },
        {
          path: '/pages/coursePreview/:courseSlug',
          name: 'coursePreview',
          component: () => import('./views/pages/course-builder/PreviewComponent.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Course Builder', url: '/pages/course-builder' },
              { title: 'Course Preview', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,

            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'View'
          }
        },

        //Course


        //Lesson

        {
          path: '/pages/lessonlist',
          name: 'lessonListing',
          component: () => import('@/views/pages/v1/lesson/LessonListing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Lessons', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'View'
          }
        },

        {
          path: '/pages/lesson',
          name: 'lesson',
          component: () => import('./views/pages/v1/lesson/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Lesson', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor'
          }
        },
        {
          path: '/pages/lesson/edit/:lesson_id',
          name: 'lesson edit',
          component: () => import('./views/pages/v1/lesson/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Lesson', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor'
          }
        },
        //lesson
        //topic
        {
          path: '/pages/topiclist',
          name: 'TopicListing',
          component: () => import('./views/pages/course-builder/ListingComponent/TopicListing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Topics', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Course',
            entity: 'View'
          }
        },


        //topic

        //<!--Question Builder Routes-->
        {
          path: '/pages/questions-builder/:formType/:type/:redirection_from',
          name: 'QuestionsV2',
          // component: () => import('./views/pages/questions/index.vue'),
          component: () => import('./views/pages/questions/newQuestionBuilder.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              // { title: 'Question Bank', url: '/pages/questionbanklist' },
              { title: 'Question Builder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/questions-builder/:formType/:type/:redirection_from/:assignment_id',
          name: 'Edit QuestionsV2',
          // component: () => import('./views/pages/questions/index.vue'),
          component: () => import('./views/pages/questions/newQuestionBuilder.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Question Builder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/questions-builder/:formType/:type/:redirection_from/:assignment_id',
          name: 'Preview QuestionsV2',
          component: () => import('./views/pages/questions/AssignmentPreview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Question Bank', url: '/pages/questionbanklist' },
              { title: 'Question Builder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/questions-preview',
          name: 'QuestionsPreview',
          component: () => import('./views/pages/question_preview/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Question Builder', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Question Bank',
            entity: 'View'
          }
        },

        {
          path: '/pages/questionbanklist',
          name: 'QuestionsBankList',
          component: () => import('./views/pages/questions/questionbank-list.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Question Bank', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Question Bank',
            entity: 'View'
          }
        },

        //<!--Question Builder Routes-->
        //attendance
        {
          path: '/pages/attendance',
          name: 'attendance',
          component: () => import('./views/pages/v1/attendance/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Student Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        },

        //coursework
        {
          path: '/pages/coursework',
          name: 'Coursework',
          component: () => import('./views/pages/v1/coursework/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Coursework', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Coursework',
            entity: 'View'
          }
        },

        {
          path: '/pages/coursework-details/:assignment_builder_user_id/:client_user/:assignment_type_id',
          name: 'coursework-details',
          component: () => import('./views/pages/v1/coursework/details.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Coursework', url: '/pages/coursework#courseWork' },
              { title: 'Coursework Details', active: true  }
            ],
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
          }
        },
        {
          path: '/pages/exam-details/:assignment_builder_user_id/:client_user/:assignment_type_id',
          name: 'exam-details',
          component: () => import('./views/pages/v1/coursework/details.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Exam', url: '/pages/exam#exam' },
              { title: 'Exam Details', active: true  }
            ],
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/report-details/:assignment_builder_user_id/:client_user',
          name: 'report-details',
          component: () => import('./views/pages/v1/coursework/Reports/Report/reportDetails.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Reports', url: '/pages/reports#report' },
              { title: 'Reports Details', active: true  }
            ],
            authRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },


        //attendance-teacher
        {
          path: '/pages/attendance-teacher',
          name: 'attendanceTeacher',
          component: () => import('./views/pages/v1/attendance/teacher.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Teacher Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        },

        //attendance-teacher

        {
          path: '/pages/each-attendance',
          name: 'singleStudentAttendance',
          component: () => import('./views/pages/attendance/eachAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        },

        {
          path: '/pages/each-attendance-teacher',
          name: 'singleTeacherAttendance',
          component: () => import('./views/pages/attendance/eachTeacherAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Teacher Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        },
        //attendance

        {
          path: '/pages/each-class-attendance',
          name: 'singleStudentClassAttendance',
          component: () => import('./views/pages/classes/components/attendance/eachAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Student Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        },

        {
          path: '/pages/each-class-teacher-attendance',
          name: 'singleTeacherClassAttendance',
          component: () => import('./views/pages/classes/components/attendance/eachTeacherAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Teacher Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        },

        /*   {
          path: '/pages/each-attendance-teacher',
          name: 'singleTeacherAttendance',
          component: () => import('./views/pages/attendance/eachTeacherAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attendance', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Attendance',
            entity: 'fetchAttendance'
          }
        }, */


        //tag
        {
          path: '/pages/tags',
          name: 'Tags',
          component: () => import('./views/pages/tags/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Tag Management', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        //tag


        //Education Route


        //Analytic Main Route
        {
          path: '/graph',
          name: 'Graph',
          component: () => import('./views/pages/Graph/index.vue'),
          meta: {
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Analytics',
            entity: 'fetchGraphsList'
          }
        },

        {
          path: '/pages/summery-settings',
          name: 'Summery Settings',
          component: () => import('./views/pages/analytics/summerySettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Summary Settings', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Analytics',
            entity: 'View'

          }
        },


        //Analytic Main Route


        //Facilities Main Route


        //room
        {
          path: '/pages/rooms',
          name: 'rooms',
          component: () => import('./views/pages/rooms/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rooms', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Rooms and Inventory',
            entity: 'listRoom'
          }
        },
        {
          path: '/pages/rooms-details',
          name: 'rooms-details',
          component: () => import('./views/pages/rooms/detailspage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rooms', active: '/pages/rooms-details' },
              { title: 'Rooms Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Rooms and Inventory',
            entity: 'listRoom'
          }
        },
        //room


        //inventory
        {
          path: '/pages/inventory-details',
          name: 'inventory-details',
          component: () => import('./views/pages/rooms/inventoryDetails.vue'),
          meta: {
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Rooms and Inventory',
            entity: 'listInventory'
          }
        },

        {
          path: '/pages/inventory',
          name: 'inventory',
          component: () => import('./views/pages/rooms/inventory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Inventory', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Rooms and Inventory',
            entity: 'listInventory'
          }
        },

        //inventory


        //Facilities Main Route


        //Communication Setting


        {
          path: '/pages/email',
          name: 'Email',
          component: () => import('./views/pages/email/emailIndex.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Email', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true,
            module: 'Communication',
            entity: 'compose'
          }
        },
        {
          path: '/pages/email/details',
          name: 'Email_Details',
          component: () => import('./views/pages/email/email_details.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Email', url: '/pages/email' },
              { title: 'Email Details', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          },
          beforeEnter: (to, from, next) => {
            to.meta.breadcrumb[2].url = `/pages/email#${to.params.details_page_type}`
            next();
          }
        },

        //notification
        {
          path: '/pages/notification',
          name: 'notification',
          component: () => import('./views/pages/notification/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Notification', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        {
          path: '/pages/notification-template',
          name: 'notification-template',
          component: () => import('./views/pages/notification-template/notificationTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Notification Template', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        //notification

        //sms

        {
          path: '/pages/sms',
          name: 'SMS',
          component: () => import('./views/pages/sms/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'SMS', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Communication',
            entity: 'SendSms'
          }
        },
        {
          path: '/pages/sms-template',
          name: 'sms-template',
          component: () => import('./views/pages/sms/SMSTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'SMS Template', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        //sms

        // blogs and post
        {
          path: '/pages/blogs-post',
          name: 'Blogs-Post',
          component: () => import('./views/pages/post-blogs/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Blog & Post', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Communication',
            entity: 'View'
          }
        },
        {
          path: '/blogs-post/details/:Id',
          name: 'Blogs-Post-Details',
          component: () => import('./views/pages/post-blogs/detailsPost.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication Settings', url: '' },
              { title: 'Blog Post', url: '/pages/blogs-post' },
              { title: 'Blog Details', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Communication',
            entity: 'View'
          }
        },
        // blogs and post

        //chat
        {
          path: '/pages/chat',
          name: 'messaging',
          component: () => import('./views/pages/messaging/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Communication', url: '' },
              { title: 'Chat', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Communication',
            entity: 'sendChat'
          }
        },
        //chat


        //Communication Setting

        {
          path: '/pages/support-ticket',
          name: 'support-ticket',
          component: () => import('./views/pages/support ticket/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Suuport Ticket', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/campaign',
          name: 'campaign',
          component: () => import('./views/pages/campaign/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        //Education Route


        {
          path: '/pages/tasks-project',
          name: 'tasks-project',
          component: () => import('./views/pages/task-project/task-project.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Tasks & Projects', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Tasks',
            entity: 'View'
          }
        },
        {
          path: '/tasks-project',
          name: 'tasks-project-create',
          component: () => import('./views/pages/task-project/task-project-create.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Tasks & Projects', url: '/pages/tasks-project' },
              { title: 'Create / Edit', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Tasks',
            entity: 'Create'
          }
        },
        {
          path: '/tasks-project',
          name: 'project-create',
          component: () => import('./views/pages/task-project/task-project-create.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Tasks & Projects', url: '/pages/tasks-project' },
              { title: 'Create / Edit', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Projects',
            entity: 'EditProject'
          }
        },
        {
          path: '/pages/project',
          name: 'Project-Listing',
          component: () => import('./views/pages/task-project/project-listing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Education', url: '' },
              { title: 'Projects', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            module: 'Projects',
            entity: 'ViewProject'
          }
        },
        // {
        //   path: '/pages/project-details',
        //   name: 'Project-Listing',
        //   component: () => import('./views/pages/task-project/project-details.vue'),
        //   meta: {
        //     authRequired: true,
        //     customerIdRequired: true,
        //     rule: 'editor',
        //     parent: 'todo',
        //     no_scroll: true,
        //     module: 'Projects',
        //     entity: 'ViewProject'
        //   }
        // },

        //new settings page v1
        {
          path: '/pages/settings',
          name: 'v1-settings',
          component: () => import('./views/pages/v1/settings/index.vue'),
          meta: {
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },
        //User Profile
        {
          path: '/pages/user-profile/:teacher_id',
          name: 'user-profile',
          component: () => import('./views/pages/v1/user_profile/index.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Staff ', url: '/staff' },
              { title: 'Staff Details', active: true }
            ],
            rule: 'editor',
            authRequired: true,
            module: 'Teachers',
            customerIdRequired: true,
            parent: 'todo',
            no_scroll: true,
            entity: 'View'
          }
        },

        //General Settings
        //dynamic Field Management
        {
          path: '/pages/customvaluesettings',
          name: 'Custom Value Settings',
          component: () => import('./views/pages/customsettings/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/pages/customvaluesettings/:modelname',
          name: 'custom-value-list-view',
          component: () => import('./views/pages/customsettings/customdynamiclist.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization',  url: '/pages/settings' },
              { title: 'Custom View', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            parent: 'todo',
            pageTitle: 'Custom List View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/staticvaluesettings/:modelname',
          name: 'statics-value-list-view',
          component: () => import('./views/pages/customsettings/customStatics.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization',  url: '/pages/settings' },
              { title: 'Custom View', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            parent: 'todo',
            pageTitle: 'Custom List View',
            rule: 'editor'
          }
        },
        //dynamic Field

        //filter management

        {
          path: '/pages/filtermanagementlist',
          name: 'filter-list-view',
          component: () => import('./views/pages/customsettings/filterindex.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,

            rule: 'editor'
          }
        },

        {
          path: '/pages/filterlist/:modelname/:table_name',
          name: 'filter-list-module1',
          component: () => import('./views/pages/customsettings/filterdynamiclist.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization',  url: '/pages/settings' },
              { title: 'Filter List', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            pageTitle: 'Filter List',
            rule: 'editor'
          }


        },

        //filter management


        //field Management

        {
          path:  '/pages/Field-management',
          name: 'field management',
          component: () => import('./views/pages/customFieldRearrage/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Field Rearrangement', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path:  '/pages/Field-management/:module_name/:table_name',
          name: 'field-re-arrange',
          component: () => import('./views/pages/customFieldRearrage/RearrangeManagement'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization',  url: '/pages/settings' },
              { title: 'Custom View', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true
          }
        },


        //field Management

        //status management

        {
          path:  '/pages/statusmanagement',
          name: 'status management',
          component: () => import('./views/pages/statusManagement/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Module Customization',  url: '/pages/settings' },
              { title: 'Status Management', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true
          }
        },


        //status management
        //role management//
        //settings
        {
          path:  '/pages/rolemanagement',
          name: 'role-management',
          component: () => import('./views/pages/roleManagement/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Role Management', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path: '/pages/rolemanagement/:name/:moduleId',
          name: 'role-module-set-access',
          component: () => import('./views/pages/roleManagement/roleModuleSelection.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Role Management', url: '/pages/rolemanagement' },
              { title: 'Roles & Access Permissions', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true
          }
        },

        {
          path: '/pages/rolesubmoduleselection/:name/:moduleId',
          name: 'role-user-module-access',
          component: () => import('./views/pages/roleManagement/roleSubModuleSelection.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Role Management', url: '/pages/rolemanagement' },
              { title: 'User Profile', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            no_scroll: true
          }
        },

        //role manageemnt//

        //communication Setting

        {
          path: '/pages/communication/settings',
          name: 'CommunicationSettings',
          component: () => import('./views/pages/communication/settings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'General Settings', url: '' },
              { title: 'Communication Settings', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },

        {
          path: '/pages/settings1',
          name: 'Settings',
          component: () => import('./views/pages/settings/index.vue'),
          meta: {
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },

        {
          path: '/pages/create-certificates',
          name: 'create-certificates',
          component: () => import('./views/pages/Testing/tinyMce.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Certificate', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },
        {
          path: '/pages/certificate-preview',
          name: 'CertificatePreview',
          component: () => import('./views/pages/Testing/previewCertificatePage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Certificate', url: '' },
              { title: 'Certificate Preview', active: true }
            ],
            authRequired: true,
            customerIdRequired: true,
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            entity: 'View'
          }
        },
        {
          path: '/pages/certificate-listing',
          name: 'certificate-listing',
          component: () => import('./views/pages/Testing/certificateListing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Certificate', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },

        {
          path: '/pages/certificate-listing',
          name: 'certificate-listing',
          component: () => import('./views/pages/Testing/certificateListing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Certificate Listing', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },

        {
          path: 'gdrivetesting',
          name: 'gdrive-listing',
          component: () => import('./views/pages/Testing/gdrive.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Certificate Listing', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },

        {
          path: 'certificate_testing',
          name: 'certificate-listing',
          component: () => import('./views/pages/Testing2/certificate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Certificate Listing', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true,
            authRequired: true,
            customerIdRequired: true
          }
        },

        //Communication Setting

        //General Settings

        //Copying code from scoolio

        //changed by yasin


        // =============================================================================
        // Application Routes
        // =============================================================================

        /*
                  Below route is for demo purpose
                  You can use this route in your app
                    {
                        path: '/apps/eCommerce/item/',
                        name: 'ecommerce-item-detail-view',
                        redirect: '/apps/eCommerce/shop',
                    }
                */
        // =============================================================================
        // UI ELEMENTS
        // =============================================================================

        // =============================================================================
        // COMPONENT ROUTES
        // =============================================================================

        // =============================================================================
        // FORMS
        // =============================================================================
        // =============================================================================
        // FORM ELEMENTS
        // =============================================================================

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/v1/user_profile_settings'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        }

        // =============================================================================
        // CHARTS & MAPS
        // =============================================================================
        // =============================================================================
        // EXTENSIONS
        // =============================================================================

      ]
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: '/pages/switch',
          name: 'page-switch',
          component: () => import('@/views/pages/login/SwitchAccount.vue'),
          meta: {
            rule: 'editor',
            authRequired: true,
            customerIdRequired: false

          }
        },
        {
          path: 'redirectgoogle',
          name: 'redirectgoogle',
          component: () => import('./views/pages/google-authenticate/googleauthenticate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Authentication', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        {
          path: '/*/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/*/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        // {
        //   path: '/signup',
        //   name: 'signup',
        //   component: () => import('@/views/pages/v1/signup/index.vue'),
        //   meta: {
        //     rule: 'editor',
        //     customerIdRequired: false
        //   }
        // },
        {
          path: '/signup',
          query: { plan_id: '' },
          name: 'signup',
          component: () => import('@/views/pages/v1/signup/index.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/pages/signin',
          name: 'google-signin-redirect',
          component: () => import('@/views/pages/sso/index.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/Forgot-password.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/pages/Password-setup',
          name: 'password-setup',
          component: () => import('@/views/pages/Password-setup.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/permission-denied',
          name: 'Permission denied',
          component: () => import('@/views/NoPermission.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  document.body.classList.remove('overflow-hidden')
  if (to.meta.authRequired) {
    if (to.meta.customerIdRequired) {
      if (!store.getters.isUserLoggedIn) {
        router.push({ path: '/pages/login', query: { to: to.path } }).catch(() => {})
      } else if (store.getters.customerId === null) {
        router.push({ path: '/pages/switch', query: { to: to.path } }).catch(() => {})
      } else if (to.meta.module) {

        if (localStorage.getItem('courseActionType') !== null && localStorage.getItem('courseActionType') === 'Edit') {
          to.meta.entity = 'Edit'
        }
        if (localStorage.getItem('courseActionType') !== null && localStorage.getItem('courseActionType') === 'customEdit') {
          to.meta.entity = 'customEdit'
        }
        if (localStorage.getItem('courseActionType') !== null && localStorage.getItem('courseActionType') === 'Shared') {
          to.meta.entity = 'View'
        }
        if (checkPermission(to.meta.module, to.meta.entity)) {
          return next()
        } else {
          router.push({ path: '/permission-denied' })
        }
      } else {

        return next()
      }
    } else if (!store.getters.isUserLoggedIn) {
      router.push({ path: '/pages/login', query: { to: to.path } }).catch(() => {})
    }
    return next()
  }
  return next()
})

export default router
